import { render, staticRenderFns } from "./ECommerceProductDetails.vue?vue&type=template&id=1357bb06&"
import script from "./ECommerceProductDetails.vue?vue&type=script&lang=js&"
export * from "./ECommerceProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceProductDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports